import {
  CLEAR_COOWNER,
  CLEAR_COOWNERS,

  DELETE_COOWNER,
  DELETE_COOWNER_ERROR,
  DELETE_COOWNER_SUCCESS,

  GET_COOWNER,
  GET_COOWNER_ERROR,
  GET_COOWNER_SUCCESS,

  GET_COOWNERS,
  GET_COOWNERS_ERROR,
  GET_COOWNERS_SUCCESS,

  SAVE_COOWNER,
  SAVE_COOWNER_ERROR,
  SAVE_COOWNER_SUCCESS,

  SAVE_SYNDICATE_SECTION,
  SAVE_SYNDICATE_SECTION_ERROR,
  SAVE_SYNDICATE_SECTION_SUCCESS,

  UPDATE_USER,
  UPDATE_USER_TWO,

  ADD_SECTION,
  ADD_SECTION_ERROR,
  ADD_SECTION_SUCCESS,

  ADD_ATTACHMENT,
  ADD_ATTACHMENT_ERROR,
  ADD_ATTACHMENT_SUCCESS,

  GET_ALL_SECTION,
  GET_ALL_SECTION_ERROR,
  GET_ALL_SECTION_SUCCESS,

  GET_ALL_SYNDICATE_SECTION,
  GET_ALL_SYNDICATE_SECTION_ERROR,
  GET_ALL_SYNDICATE_SECTION_SUCCESS,

  GET_FIELDS,
  GET_FIELDS_ERROR,
  GET_FIELDS_SUCCESS,

  ADD_FIELDS,
  ADD_FIELDS_ERROR,
  ADD_FIELDS_SUCCESS,

  DELETE_FIELDS,
  DELETE_FIELDS_ERROR,
  DELETE_FIELDS_SUCCESS,

  DELETE_SYNDICATE_FIELDS,
  DELETE_SYNDICATE_FIELDS_SUCCESS,
  DELETE__SYNDICATE_FIELDS_ERROR,

  DELETE_SETTING_SECTION,
  DELETE_SETTING_SECTION_ERROR,
  DELETE_SETTING_SECTION_SUCCESS,

  DOWNLOAD_COOWNERS,
  DOWNLOAD_COOWNERS_ERROR,
  DOWNLOAD_COOWNERS_SUCCESS,

  COOWNER_SECTION_PERMISSION,
  COOWNER_SECTION_PERMISSION_ERROR,
  COOWNER_SECTION_PERMISSION_SUCCESS,

  SECTION_TOGGLE,
  UPDATE_SECTION_VISIBILITY,

} from './constants';

export default {
  [CLEAR_COOWNER](state) {
    state.coowner = {
      userID: null,
      user2ID: null,
      unit: '',
      insurance: false,
      antitheft: false,
      share: 0,
      animal: false,
      drd: false,
      charge: 0,
      account: '',
      parking: '',
      parkingAdditional: '',
      shed: '',
      car: '',
      carAdditional: '',
      tenant: false,
      notes: '',
      coownerSectionPermission: null,
    };
  },
  [CLEAR_COOWNERS](state) {
    state.coowners = [];
  },

  [DELETE_COOWNER](state) {
    state.error = false;
    state.loading = true;
  },
  [DELETE_COOWNER_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [DELETE_COOWNER_SUCCESS](state) {
    state.coowner = false;
    state.loading = false;
  },

  [GET_COOWNER](state) {
    state.coowner = false;
    state.error = false;
    state.loading = true;
    state.success = false;
  },
  [GET_COOWNER_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_COOWNER_SUCCESS](state, payload) {
    const sectionIds = {};
    // get payload value and append key of id j-child i-parent
    const sectionData = payload.sections.map((m, i) => ({
      ...m,
      fields: m.fields === null ? [] : m.fields.map((f, j) => {
        // if (f.fieldType !== 'file') {
        sectionIds[`${j}_${i}`] = f.textData;
        return { ...f, id: `${j}_${i}` };
        // }
        // return { ...f };
      }),
    }));
    // eslint-disable-next-line no-param-reassign
    // payload.sections = sectionData;
    state.coowner = { ...payload, sections: sectionData, ...sectionIds };
    state.section = sectionData;
    state.loading = false;
  },

  [GET_COOWNERS](state) {
    state.coowners = [];
    state.error = false;
    state.loading = true;
    state.success = false;
  },
  [GET_COOWNERS_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_COOWNERS_SUCCESS](state, payload) {
    state.coowners = payload;
    state.loading = false;
  },

  [SAVE_SYNDICATE_SECTION](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [SAVE_SYNDICATE_SECTION_ERROR](state, payload) {
    state.error = payload;
    state.formLoading = false;
  },
  [SAVE_SYNDICATE_SECTION_SUCCESS](state, payload) {
    state.section = payload.sections;
    state.success = true;
    state.formLoading = false;
  },

  [SAVE_COOWNER](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [SAVE_COOWNER_ERROR](state, payload) {
    state.error = payload;
    state.formLoading = false;
  },
  [SAVE_COOWNER_SUCCESS](state, payload) {
    const sectionIds = {};
    const sectionData = payload.sections.map((m, i) => ({
      ...m,
      fields: m.fields === null ? [] : m.fields.map((f, j) => {
        // if (f.fieldType !== 'file') {
        // at the save, edit and delete time to reassign value
        sectionIds[`${j}_${i}`] = f.textData;
        return { ...f, id: `${j}_${i}` };
        // }
        // return { ...f };
      }),
    }));
    // eslint-disable-next-line no-param-reassign
    state.coowner = { ...state.coowner, ...payload, sections: sectionData };
    // state.coowner = { ...state.coowner, ...payload };
    // state.section = sectionData;
    state.success = true;
    state.formLoading = false;
  },

  [UPDATE_USER](state, payload) {
    state.coowner.userID = payload;
  },

  [UPDATE_USER_TWO](state, payload) {
    state.coowner.user2ID = payload;
  },

  [DOWNLOAD_COOWNERS](state) {
    state.downloadCoownersLink = '';
    state.success = false;
    state.error = false;
    state.exportLoading = true;
  },
  [DOWNLOAD_COOWNERS_ERROR](state, payload) {
    state.error = payload;
    state.exportLoading = false;
  },
  [DOWNLOAD_COOWNERS_SUCCESS](state, payload) {
    state.downloadCoownersLink = payload;
    state.exportLoading = false;
    state.success = false;
  },

  [ADD_SECTION](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [ADD_SECTION_ERROR](state, payload) {
    state.error = payload;
    state.formLoading = false;
  },
  [ADD_SECTION_SUCCESS](state, payload) {
    state.section.push(payload);
    state.success = true;
    state.formLoading = false;
  },

  [ADD_ATTACHMENT](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [ADD_ATTACHMENT_ERROR](state, payload) {
    state.error = payload;
    state.formLoading = false;
  },
  [ADD_ATTACHMENT_SUCCESS](state, payload) {
    state.imageURL = payload;
    state.success = true;
    state.formLoading = false;
  },

  [GET_ALL_SECTION](state) {
    state.section = {};
    state.error = false;
    state.loading = true;
    state.success = false;
  },
  [GET_ALL_SECTION_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_ALL_SECTION_SUCCESS](state, payload) {
    state.section = payload;
    state.loading = false;
  },

  [GET_ALL_SYNDICATE_SECTION](state) {
    state.section = {};
    state.error = false;
    state.loading = true;
    state.success = false;
  },
  [GET_ALL_SYNDICATE_SECTION_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_ALL_SYNDICATE_SECTION_SUCCESS](state, payload) {
    const sectionData = payload.map((m, i) => ({
      ...m,
      fields: m.fields === null ? [] : m.fields.map((f, j) => ({ ...f, id: `${j}_${i}` })),
    }));
    // eslint-disable-next-line no-param-reassign
    // payload.sections = sectionData;
    state.section = sectionData;
    state.loading = false;
  },

  [GET_FIELDS](state) {
    state.getfields = {};
    state.error = false;
    state.loading = true;
    state.success = false;
  },
  [GET_FIELDS_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_FIELDS_SUCCESS](state, payload) {
    state.getfields = payload;
    state.loading = false;
  },

  [ADD_FIELDS](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [ADD_FIELDS_ERROR](state, payload) {
    state.error = payload;
    state.formLoading = false;
  },
  [ADD_FIELDS_SUCCESS](state, payload) {
    if (payload.subField) {
      const splitId = payload.subField.split('_');
      const index1 = parseInt(splitId[0], 10);
      state.section[payload.id].fields[index1].enFieldName = payload.enFieldName;
      state.section[payload.id].fields[index1].frFieldName = payload.frFieldName;
      state.section[payload.id].fields[index1].fieldInputType = payload.fieldInputType;
      state.section[payload.id].fields[index1].textData = payload.textData;
      state.section[payload.id].fields[index1].defaultOptions = payload.defaultOptions;
    } else {
      if (state.section[payload.id].fields === null) {
        state.section[payload.id].fields = [];
      }
      state.section[payload.id].fields.push(payload);
      // generate id for new field
      state.section[payload.id].fields[state.section[payload.id].fields.length - 1].id = `${state.section[payload.id].fields.length - 1}_${payload.id}`;
      state.coowner = { ...state.coowner, ...{ [`${payload.id}`]: payload.textData } };
    }
    state.success = true;
    state.formLoading = false;
  },

  [DELETE_FIELDS](state) {
    state.error = false;
    // state.loading = true;
  },
  [DELETE_FIELDS_ERROR](state, payload) {
    state.error = payload;
    // state.loading = false;
  },
  [DELETE_FIELDS_SUCCESS](state, payload) {
    payload.forEach(({ id }) => {
      const [fieldIndex, sectionIndex] = id.split('_');
      // eslint-disable-next-line prefer-destructuring
      const fields = state.section[sectionIndex].fields;
      fields.splice(fieldIndex, 1);
    });
    const sectionIds = {};
    const sectionData = state.section.map((m, i) => ({
      ...m,
      fields: m.fields === null ? [] : m.fields.map((f, j) => {
        sectionIds[`${j}_${i}`] = f.textData;
        return { ...f, id: `${j}_${i}` };
      }),
    }));
    state.section = sectionData;
    state.coowner = { ...state.coowner, ...sectionIds };
  },

  [DELETE_SYNDICATE_FIELDS](state) {
    state.error = false;
    // state.loading = true;
  },
  [DELETE__SYNDICATE_FIELDS_ERROR](state, payload) {
    state.error = payload;
    // state.loading = false;
  },
  [DELETE_SYNDICATE_FIELDS_SUCCESS](state, payload) {
    state.section[payload[1]].fields.splice(payload[0], 1);
    state.success = true;
  },

  [DELETE_SETTING_SECTION](state) {
    state.error = false;
    // state.loading = true;
  },
  [DELETE_SETTING_SECTION_ERROR](state, payload) {
    state.error = payload;
    // state.loading = false;
  },
  [DELETE_SETTING_SECTION_SUCCESS](state, payload) {
    // for static data it compare for id
    if (payload.id) {
      state.section.splice(payload.id, 1);
    } else if (payload.coownersSectionID) { // for api data use coownersectionID
      const deleteSec = state.section.findIndex(f => f.coownersSectionID === payload.coownersSectionID);
      if (deleteSec !== -1) {
        state.section.splice(deleteSec, 1);
      }
      if (payload.isSettings === false) {
        const sectionIds = {};
        const sectionData = state.section.map((m, i) => ({
          ...m,
          fields: m.fields === null ? [] : m.fields.map((f, j) => {
            // if (f.fieldType !== 'file') {
            sectionIds[`${j}_${i}`] = f.textData;
            return { ...f, id: `${j}_${i}` };
            // }
            // return { ...f };
          }),
        }));
        state.section = sectionData;
        state.coowner = { ...state.coowner, ...sectionIds };
      }
    }
    state.success = true;
  },

  [COOWNER_SECTION_PERMISSION](state) {
    state.error = false;
    state.success = false;
  },

  [COOWNER_SECTION_PERMISSION_ERROR](state, payload) {
    state.error = payload;
    state.formLoading = false;
  },

  [COOWNER_SECTION_PERMISSION_SUCCESS](state, payload) {
    state.coownerSectionPermission = payload;
    state.success = true;
    state.formLoading = false;
  },
  [SECTION_TOGGLE](state) {
    if (Array.isArray(state.section)) {
      state.section.forEach((s) => {
        // eslint-disable-next-line no-param-reassign
        s.show = true;
      });
    }
  },
  [UPDATE_SECTION_VISIBILITY](state, { sectionId, isVisible }) {
    // if (Array.isArray(state.section)) {
    const index = state.section.findIndex(item => item.coownersSectionID === sectionId);
    if (index !== -1) {
      // eslint-disable-next-line no-param-reassign
      state.section[index].show = isVisible;
    }
    // }
  },

  // single object item mutation
  updateItem(state, payload) {
    state.coowner[payload.item] = payload.value;
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Coowners/mutations.js